import React from "react";
import PropTypes from "prop-types";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Modal from "@/components/ui/modal";
import { Loader2, ShieldCheck, Check } from "lucide-react";

const PinVerificationModal = ({
  show,
  onHide,
  pinVerifying,
  pinActionTitle,
  handleVerifyPin,
  pinValue,
  setPinValue,
}) => {
  return (
    <Modal
      open={show}
      onOpenChange={(open) => !pinVerifying && !open && onHide()}
      title={pinActionTitle ? `Verify ${pinActionTitle}` : "PIN Verification"}
      icon={ShieldCheck}
      maxWidth="max-w-md"
      footer={
        <Button
          className="w-full py-6 text-lg font-bold shadow-lg"
          onClick={handleVerifyPin}
          disabled={pinVerifying || pinValue.length < 4}
        >
          {pinVerifying ? (
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
          ) : (
            <Check className="mr-2 h-5 w-5" />
          )}
          Verify PIN
        </Button>
      }
    >
      <div className="space-y-6 text-center">
        <p className="text-sm text-muted-foreground">
          Enter your 4-6 digit access pin to authorize this action.
        </p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleVerifyPin();
          }}
          className="flex justify-center"
        >
          <Input
            type="password"
            className="max-w-[240px] h-16 text-center text-3xl font-bold tracking-[1em] border-2 focus-visible:ring-primary h-12"
            placeholder="****"
            maxLength={6}
            value={pinValue}
            onChange={(e) => setPinValue(e.target.value.replace(/\D/g, ""))}
            autoFocus
            disabled={pinVerifying}
          />
        </form>
      </div>
    </Modal>
  );
};

PinVerificationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  pinVerifying: PropTypes.bool,
  pinActionTitle: PropTypes.string,
  handleVerifyPin: PropTypes.func.isRequired,
  pinValue: PropTypes.string.isRequired,
  setPinValue: PropTypes.func.isRequired,
};

export default PinVerificationModal;
